/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_Other_Title_LevelInputs */

const en_salary_negotiate_other_title_level = /** @type {(inputs: Salary_Negotiate_Other_Title_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title / level upgrade`)
};

const de_salary_negotiate_other_title_level = /** @type {(inputs: Salary_Negotiate_Other_Title_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel- / Stufen-Upgrade`)
};

const fr_salary_negotiate_other_title_level = /** @type {(inputs: Salary_Negotiate_Other_Title_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titre / niveau supérieur`)
};

const es_salary_negotiate_other_title_level = /** @type {(inputs: Salary_Negotiate_Other_Title_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mejora de título / nivel`)
};

const it_salary_negotiate_other_title_level = /** @type {(inputs: Salary_Negotiate_Other_Title_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titolo / upgrade di livello`)
};

const nl_salary_negotiate_other_title_level = /** @type {(inputs: Salary_Negotiate_Other_Title_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel / niveauverhoging`)
};

const pl_salary_negotiate_other_title_level = /** @type {(inputs: Salary_Negotiate_Other_Title_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tytuł / awans na wyższy poziom`)
};

const fi_salary_negotiate_other_title_level = /** @type {(inputs: Salary_Negotiate_Other_Title_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nimike / tason nosto`)
};

const da_salary_negotiate_other_title_level = /** @type {(inputs: Salary_Negotiate_Other_Title_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel / niveauopgradering`)
};

const sv_salary_negotiate_other_title_level = /** @type {(inputs: Salary_Negotiate_Other_Title_LevelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel / nivåuppgradering`)
};

/**
* | output |
* | --- |
* | "Title / level upgrade" |
*
* @param {Salary_Negotiate_Other_Title_LevelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_other_title_level = /** @type {((inputs?: Salary_Negotiate_Other_Title_LevelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_Other_Title_LevelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_other_title_level(inputs)
	if (locale === "fr") return fr_salary_negotiate_other_title_level(inputs)
	if (locale === "es") return es_salary_negotiate_other_title_level(inputs)
	if (locale === "it") return it_salary_negotiate_other_title_level(inputs)
	if (locale === "nl") return nl_salary_negotiate_other_title_level(inputs)
	if (locale === "pl") return pl_salary_negotiate_other_title_level(inputs)
	if (locale === "fi") return fi_salary_negotiate_other_title_level(inputs)
	if (locale === "da") return da_salary_negotiate_other_title_level(inputs)
	if (locale === "sv") return sv_salary_negotiate_other_title_level(inputs)
	return en_salary_negotiate_other_title_level(inputs)
});